<template>
    <div class="preservation-zjxx">
        <Slogan theTitle="证据信息"/>
        <van-cell-group class="zjxx-box" v-for="(item, index) in this.bqZjxx" :key="index">
            <van-field
                v-model="item.nZjlx"
                readonly
                label="证据类型"
                @click="toastJointZjxx(item.nZjlx)"
            ></van-field>
            <van-field
                v-model="item.cZjmc"
                readonly
                label="证据名称"
            ></van-field>
            <van-field
                v-model="item.nYjwj"
                readonly
                label="原件原物"
            ></van-field>
            <van-field
                v-model="item.cZjly"
                readonly
                label="证据来源"
                @click="toastJointZjxx(item.cZjly)"
            ></van-field>
        </van-cell-group>
    </div>
</template>

<script>
    import Slogan from '../../../components/common/slogan'
    import {getXcxZjList} from "@/api/guarantee";
    import {zjlxType, yjwjType} from "@/filters";
    import {Toast} from "vant";

    export default {
    name: "previewZJXX",
        data() {
            return {
                bqZjxx:[]
            };
        },
        // 注入
        inject: ['bqid'],
        components: {Slogan},
        methods: {
            toastJointZjxx(value){
                if(!value){
                    return
                }
                Toast(value);
            },
            getBqZjxx(){
                let bqid = this.bqid
                getXcxZjList({bqid}).then(res=>{
                    if(res.code===200&&res.data.length>0){
                        res.data.map(item=>{
                            this.bqZjxx.push({
                                cId:item.cId,
                                nZjlx: zjlxType(item.nZjlx),
                                cZjmc: item.cZjmc,
                                nYjwj: yjwjType(item.nYjwj),
                                cZjly: item.cZjly,
                            });
                        });
                    }
                });
            }
        },
        mounted() {
            this.getBqZjxx()
        }
    }
</script>

<style lang="less"  scoped>
.zjxx-box {
    position: relative;
    &:last-child{
        margin-bottom: 0;
    }
}
</style>
